// ドラッグと判定するまでの移動量(px)。
// しきい値なしで即スクロールすると、クリック時のわずかな手ブレでも行が動き、
// mousedown と mouseup で「カーソル下の要素」が変わってしまう。その場合ブラウザは click を
// アイコンではなく共通の親要素へ発火するため、アイコンのクリックハンドラが呼ばれない
// （＝キャンペーンが開かない）。アイコンが画面内に収まらず横スクロールできる場合（例: 連携配信で
// サムネイルが多数並ぶリール型）に顕在化する。
const DRAG_THRESHOLD_PX = 5;

export function enableMouseDragScroll(element) {
  if (!element || element.dataset.storeeelMouseDragScrollBound === 'true') return;
  element.dataset.storeeelMouseDragScrollBound = 'true';

  let isPointerDown = false;
  let isDragging = false;
  // ドラッグ直後の click（＝スクロール操作の副産物）でキャンペーンが開かないよう1回だけ抑止する
  let suppressNextClick = false;
  let startX = 0;
  let scrollLeft = 0;
  let previousUserSelect = '';
  let previousWebkitUserSelect = '';
  const doc = element.ownerDocument;
  const win = doc.defaultView || window;

  const disableTextSelection = () => {
    // ドラッグスクロール中だけ選択を止め、青い選択ハイライトを防ぐ
    previousUserSelect = doc.body.style.userSelect;
    previousWebkitUserSelect = doc.body.style.webkitUserSelect;
    doc.body.style.userSelect = 'none';
    doc.body.style.webkitUserSelect = 'none';
  };

  const restoreTextSelection = () => {
    doc.body.style.userSelect = previousUserSelect;
    doc.body.style.webkitUserSelect = previousWebkitUserSelect;
  };

  const beginDrag = () => {
    isDragging = true;
    element.classList.add('dragging');
    disableTextSelection();
  };

  const finishDrag = () => {
    if (isDragging) {
      // mouseup の直後に click が来るため、ここでフラグを立てて click 側で握りつぶす
      suppressNextClick = true;
      restoreTextSelection();
    }
    isPointerDown = false;
    isDragging = false;
    element.classList.remove('dragging');
  };

  element.addEventListener('mousedown', (e) => {
    if (e.button !== 0) return;
    // ドラッグ後に click が発生しなかった場合に抑止フラグが残らないよう、押下のたびに解除する
    suppressNextClick = false;
    isPointerDown = true;
    isDragging = false;
    startX = e.pageX - element.offsetLeft;
    scrollLeft = element.scrollLeft;
  });

  element.addEventListener('mouseleave', finishDrag);
  element.addEventListener('mouseup', finishDrag);
  win.addEventListener('mouseup', finishDrag);

  element.addEventListener('mousemove', (e) => {
    if (!isPointerDown) return;
    const x = e.pageX - element.offsetLeft;
    // しきい値を超えるまではスクロールしない（クリックの取りこぼしを防ぐ）
    if (!isDragging) {
      if (Math.abs(x - startX) < DRAG_THRESHOLD_PX) return;
      beginDrag();
    }
    e.preventDefault();
    const walk = (x - startX) * 1.5; // スクロール速度調整
    element.scrollLeft = scrollLeft - walk;
  });

  // ドラッグでスクロールしたときの click はアイコンのタップとして扱わない
  element.addEventListener('click', (e) => {
    if (!suppressNextClick) return;
    suppressNextClick = false;
    e.preventDefault();
    e.stopPropagation();
  }, true);

  element.addEventListener('selectstart', (e) => {
    if (isDragging) e.preventDefault();
  });

  element.addEventListener('dragstart', (e) => {
    e.preventDefault();
  });
}
